export function telNumber(event: React.FormEvent<HTMLInputElement>) {
  event.currentTarget.maxLength = 15

  const value = event.currentTarget.value
  let phoneNumber = value.replace(/\D/g, '')
  phoneNumber = phoneNumber.replace(/(\d{2})(\d)/, '($1) $2')
  phoneNumber = phoneNumber.replace(/(\d{5})(\d{4})$/, '$1-$2')
  event.currentTarget.value = phoneNumber
  return event
}

export function cep(event: React.FormEvent<HTMLInputElement>) {
  event.currentTarget.maxLength = 9
  const value = event.currentTarget.value
  let cepNumber = value.replace(/\D/g, '')
  cepNumber = value.replace(/^(\d{5})(\d{3})/, '$1-$2')
  event.currentTarget.value = cepNumber
  return event
}
